import React, { PropsWithChildren } from 'react';
import './TabsList.scss';

export const TabsList = ({ children }: PropsWithChildren<any>): JSX.Element => (
  <div className="tabs__list">
    {children}
  </div>
);
